import { type HTMLProps, type Ref, useMemo } from 'react';

import { useComponentBoundingBox } from './useComponentBoundingBox';

const useAutoImageHeight = <T extends HTMLElement = HTMLDivElement>(
  heightToWidthRatio: number,
): Pick<HTMLProps<T>, 'style'> & { ref: Ref<T> } => {
  const [ref, size] = useComponentBoundingBox<T>();

  return useMemo(
    () => ({
      ref,
      style: { height: (size?.width ?? 0) * heightToWidthRatio },
    }),
    [heightToWidthRatio, ref, size],
  );
};

export default useAutoImageHeight;
